import React from "react";
import styled from "styled-components";
import { ChevronDown } from "@sonder/ui/source/icons";
import { Dropdown } from "@sonder/ui/source/styled/components/Dropdown";
import { DropdownContent } from "@sonder/ui/source/styled/components/DropdownContent";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { InputGroup } from "@sonder/ui/source/styled/fragments/InputGroup";
import { useSegment } from "analytics/segment";
import { setGroupByOptions } from "tasks/actions";
import { useStore } from "tasks/store";

const GroupsDropdownContent = styled(DropdownContent)`
  flex-direction: column;
  button {
    border: none;
    margin: 0.1rem 0;
  }
`;
const GroupByLabel = styled.h5`
  white-space: nowrap;
`;

// Exports
export const Groups = () => {
  const {
    state: { groupBy },
    dispatch,
  } = useStore();
  const { track } = useSegment();

  return (
    <InputGroup>
      <GroupByLabel>Group By:</GroupByLabel>
      <Dropdown
        trigger={
          <Button iconRight>
            {groupBy === "due-date" ? "Due Date" : "Everything"}
            <ChevronDown />
          </Button>
        }
        onClose={() =>
          track({
            eventName: "view_header",
            action: "click",
            element: "group_by_menu.dropdown_trigger",
            props: { nextValue: "closed" },
          })
        }
        onOpen={() =>
          track({
            eventName: "view_header",
            action: "click",
            element: "group_by_menu.dropdown_trigger",
            props: { nextValue: "opened" },
          })
        }
      >
        {({ isOpen, closePortal }) =>
          isOpen && (
            <GroupsDropdownContent>
              <Button
                selected={groupBy === "due-date"}
                onClick={() => {
                  closePortal();
                  track({
                    eventName: "view_header",
                    action: "click",
                    element: `group_by_menu.due_date_button`,
                  });
                  dispatch(setGroupByOptions("due-date"));
                }}
              >
                Due Date
              </Button>
              <Button
                selected={groupBy === "everything"}
                onClick={() => {
                  closePortal();
                  track({
                    eventName: "view_header",
                    action: "click",
                    element: `group_by_menu.everything_button`,
                  });
                  dispatch(setGroupByOptions("everything"));
                }}
              >
                Everything
              </Button>
            </GroupsDropdownContent>
          )
        }
      </Dropdown>
    </InputGroup>
  );
};
